export default {
    init() {
        this.userRoleSelect();
        this.userFormButtonDisable();
        this.uploadUserImage();
    },

    userRoleSelect() {
        let select = $('.user-role-select select');
        if (select.length > 0) {
            select.select2({ dropdownAutoWidth: true, width: 'resolve', dropdownCssClass: "radio-dropdown"});
        }
    },

    userFormButtonDisable(){
        $(".account-edit-form input").keyup(function() {
            $(".account-info--body button").removeClass('disabled');
        });
    },

    uploadUserImage() {
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let importFileInput = $('.user-icon-file');
        let frImportFileInputParent = $('.account-info--upload-img');
        let errorMsg = frImportFileInputParent.parent().find('.error-message');

        importFileInput.on('change', function () {
            if ($(this)[0].files.length > 0) {
                let file = $("input[type=file]").get(0).files[0];
                let isSuccess = true;
                let extension = file.name.split('.').pop().toLowerCase();
                if ( !(fileTypes.indexOf(extension) > -1) ) {
                    isSuccess = false;
                    frImportFileInputParent.addClass('error');
                    errorMsg.show(300);
                }

                if(isSuccess){
                    frImportFileInputParent.removeClass('error');
                    errorMsg.hide();
                    var reader = new FileReader();
                    reader.onload = function(){
                        $('.account-info--heading .user-image').css('background', 'transparent url('+reader.result +') center no-repeat');
                        $('.account-info--heading .user-image').css('background-size','cover');
                    }
                    reader.readAsDataURL(file);
                }
            }
        });
    }
}